import script from "./TextWithLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextWithLabel.vue?vue&type=script&setup=true&lang=ts"

import "./TextWithLabel.vue?vue&type=style&index=0&id=3e874230&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e874230"]])

export default __exports__